import logger from './utils/logger';

//const config = {
  //apiUrl: 'http://localhost:5002',
//  apiUrl: 'https://backend-rough-bird-115.fly.dev',
//};

// Remove the /api suffix if it exists to avoid duplicate /api in API calls
const API_URL = (process.env.REACT_APP_API_URL || 'https://backend-rough-bird-115.fly.dev').replace(/\/api$/, '');
logger.debug('API_URL:', API_URL);
export default API_URL;
//export default config;
